// tslint:disable
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import RolesModal from '../../components/popup/roles-modal';
import Switch from 'react-switch';
import { Modal, Table } from 'reactstrap';
import Paginate from '../../components/table/paginate';
import { Confirm } from '../../components/notification/main';
import Roles from './roles';

const T = Translator.create();
let _common: Common;
const dummyData = {
    "admin": {
      "roles": [
        {
          "id": "1",
          "name": "Xyz 1",
          "users": [
              {
              "name": "Kemal",
              "surname": "Sahin",
              "username": "Ks"
              },
              {
              "name": "Kemal 2 ",
              "surname": "Sahin 2",
              "username": "Ks 2"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": false,
            "delete": false,
            "email": false
          },
          "announcementOperations": {
            "create": false,
            "delete": true,
            "email": true
          },
          "questionBankOperations": {
            "create": true,
            "delete": true,
            "email": true
          },
          "helpOperations": {
            "create": false,
            "delete": true,
            "email": true
          }
        }

        },
        {
          "id": "2",
          "name": "Xyz 2",
          "users": [
              {
              "name": "Kemal 33",
              "surname": "Sahin 33",
              "username": "Ks33"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": true,
            "delete": false,
            "email": false
          },
          "announcementOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "questionBankOperations": {
            "create": false,
            "delete": false,
            "email": true
          },
          "helpOperations": {
            "create": true,
            "delete": true,
            "email": true
          }
        }

        }
      ]
    },
    "programAdmin": {
      "roles": [
        {
          "id": "3",
          "name": "Xyz 3",
          "users":[
              {
              "name": "Kemal 3",
              "surname": "Sahin 3",
              "username": "Ks 3"
              },
              {
              "name": "Kemal 4 ",
              "surname": "Sahin 4",
              "username": "Ks 4"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": false,
            "delete": false,
            "email": false
          },
          "announcementOperations": {
            "create": true,
            "delete": true,
            "email": true
          },
          "questionBankOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "helpOperations": {
            "create": true,
            "delete": false,
            "email": false
          }
        }

        },
        {
          "id": "4",
          "name": "Xyz 4",
          "users":[
              {
              "name": "Kemal 13",
              "surname": "Sahin 13",
              "username": "Ks 13"
              },
              {
              "name": "Kemal 14 ",
              "surname": "Sahin 14",
              "username": "Ks 14"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "announcementOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "questionBankOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "helpOperations": {
            "create": true,
            "delete": false,
            "email": true
          }
        }

        }
      ]
    },
    "educator": {
     "roles": [
        {
          "id": "5",
          "name": "Xyz 5",
          "users":[
              {
              "name": "Kemal 5",
              "surname": "Sahin 5",
              "username": "Ks 5"
              },
              {
              "name": "Kemal 6",
              "surname": "Sahin 6",
              "username": "Ks 6"
              },
              {
              "name": "Kemal 66",
              "surname": "Sahin 66",
              "username": "Ks 66"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": false,
            "delete": false,
            "email": true
          },
          "announcementOperations": {
            "create": false,
            "delete": false,
            "email": false
          },
          "questionBankOperations": {
            "create": true,
            "delete": false,
            "email": false
          },
          "helpOperations": {
            "create": false,
            "delete": false,
            "email": true
          }
        }

        },
        {
          "id": "6",
          "name": "Xyz 6",
          "users":[
              {
              "name": "Kemal 7",
              "surname": "Sahin 7",
              "username": "Ks 7"
              },
              {
              "name": "Kemal 7",
              "surname": "Sahin 7",
              "username": "Ks 7"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "announcementOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "questionBankOperations": {
            "create": true,
            "delete": false,
            "email": true
          },
          "helpOperations": {
            "create": true,
            "delete": false,
            "email": true
          }
        }

        }
      ]
    },
    "student": {
     "roles": [
        {
          "id": "7",
          "name": "Xyz 7",
            "users":[
              {
              "name": "Kemal 8",
              "surname": "Sahin 8",
              "username": "Ks 8"
              },
              {
              "name": "Kemal 9",
              "surname": "Sahin 9",
              "username": "Ks 9"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": true,
            "delete": true,
            "email": true
          },
          "announcementOperations": {
            "create": false,
            "delete": false,
            "email": false
          },
          "questionBankOperations": {
            "create": true,
            "delete": true,
            "email": true
          },
          "helpOperations": {
             "create": false,
            "delete": false,
            "email": true
          }
        }

        },
        {
          "id": "8",
          "name": "Xyz 8",
          "users":[
              {
              "name": "Kemal 9",
              "surname": "Sahin 9",
              "username": "Ks 9"
              },
              {
              "name": "Kemal 10",
              "surname": "Sahin 10",
              "username": "Ks 10"
              }
          ],
         "settings":
        {
          "activityOperations": {
            "create": false,
            "delete": false,
            "email": true
          },
          "announcementOperations": {
            "create": false,
            "delete": true,
            "email": true
          },
          "questionBankOperations": {
            "create": true,
            "delete": true,
            "email": true
          },
          "helpOperations": {
            "create": false,
            "delete": false,
            "email": true
          }
        }

        }
      ]
    }
  };
class RolesPage extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.state={
            existRole: true,
            filterModalOpen: false,
            editRole: false,
            viewUsersModal: false,

            activitySettings: true,
            createActivity: -1,
            deleteActivity: -1,
            emailActivity: -1,

            questionBankProcess: true,
            createQuestion: -1,
            deleteQuestion: -1,
            emailQuestion: -1,

            helpProcess: true,
            createHelp: -1,
            deleteHelp: -1,
            emailHelp: -1,

            announcementProcess: true,
            createAnnouncement: -1,
            deleteAnnouncement: -1,
            emailAnnouncement: -1,

            roleStatus: false,
            roleData: {},
            selectedRole: {},
            selectedRoleType: '',
            selectedRoleUsers: {}

        }
    }

    triggerRoleModal = () => {

        let filterModalOpenStatus = false;
        if (!this.state.filterModalOpen)
        {
            filterModalOpenStatus = true;
        }

        this.setState({
            filterModalOpen: filterModalOpenStatus
        });
    };

    deleteActivityConfirmClick = () => {

    }

    deleteModal = () => {
        Confirm.setConfirm('normal', this.deleteActivityConfirmClick, T.t('r_delete_arole_confirm'), T.t('r_delete_arole_confirm'), null);

    };

    editRoleFunc = (roleId: string, roleType: string) =>
    {
        this.setState((prevState: any) => (
            {activitySettings: true,
             questionBankProcess: true,
             helpProcess: true,
            announcementProcess: true,
            createAnnouncement: -1,
            deleteAnnouncement: -1,
            emailAnnouncement: -1,
            createHelp: -1,
            deleteHelp: -1,
            emailHelp: -1,
            createQuestion: -1,
            deleteQuestion: -1,
            emailQuestion: -1,
            createActivity: -1,
            deleteActivity: -1,
            emailActivity: -1,
        }))
        this.setState({editRole: true, selectedRoleType: roleType, selectedRole: this.state.roleData[roleType].roles.filter((item: any) => item.id === roleId)[0]});
    }

    switchEdit = (param: any, value: string) =>
    {
        let activitySettingsValue = this.state.activitySettings;
        let questionBankProcessValue = this.state.questionBankProcess;
        let helpProcessValue = this.state.helpProcess;
        let announcementProcessValue = this.state.announcementProcess;
        let createAnnouncementValue = this.state.createAnnouncement;
        let deleteAnnouncementValue = this.state.deleteAnnouncement;
        let emailAnnouncementValue = this.state.emailAnnouncement;
        let createHelpValue = this.state.createHelp;
        let deleteHelpValue = this.state.deleteHelp;
        let emailHelpValue = this.state.emailHelp;
        let createQuestionValue = this.state.createQuestion;
        let deleteQuestionValue = this.state.deleteQuestion;
        let emailQuestionValue = this.state.emailQuestion;
        let createActivityValue = this.state.createActivity;
        let deleteActivityValue = this.state.deleteActivity;
        let emailActivityValue = this.state.emailActivity;

        if (param == "activitySettings")
        {
            activitySettingsValue = value;
        }
        else if (param == "questionBank")
        {
            questionBankProcessValue = value;
        }
        else if (param == "help")
        {
            helpProcessValue = value;
        }
        else if (param == "announcement")
        {
            announcementProcessValue = value;
        }
        else if (param == "createAnnouncement")
        {
            createAnnouncementValue = value;
        }
        else if (param == "deleteAnnouncement")
        {
            deleteAnnouncementValue = value;
        }
        else if (param == "emailAnnouncement")
        {
            emailAnnouncementValue = value;
        }
        else if (param == "createHelp")
            {
                createHelpValue = value;
            }
            else if (param == "deleteHelp")
            {
                deleteHelpValue = value;
            }
            else if (param == "emailHelp")
            {
                emailHelpValue = value;
            }
            else if (param == "createQuestion")
                {
                    createQuestionValue = value;
                }
                else if (param == "deleteQuestion")
                {
                    deleteQuestionValue = value;
                }
                else if (param == "emailQuestion")
                {
                    emailQuestionValue = value;
                }
                else if (param == "createActivity")
                    {
                        createActivityValue = value;
                    }
                    else if (param == "deleteActivity")
                    {
                        deleteActivityValue = value;
                    }
                    else if (param == "emailActivity")
                    {
                        emailActivityValue = value;
                    }

        this.setState((prevState: any) => (
            {activitySettings: activitySettingsValue, questionBankProcess: questionBankProcessValue, helpProcess: helpProcessValue,
            announcementProcess: announcementProcessValue,
            createAnnouncement: createAnnouncementValue,
            deleteAnnouncement: deleteAnnouncementValue,
            emailAnnouncement: emailAnnouncementValue,
            createHelp: createHelpValue,
            deleteHelp: deleteHelpValue,
            emailHelp: emailHelpValue,
            createQuestion: createQuestionValue,
            deleteQuestion: deleteQuestionValue,
            emailQuestion: emailQuestionValue,
            createActivity: createActivityValue,
            deleteActivity: deleteActivityValue,
            emailActivity: emailActivityValue,
        }))
    }

    onPageChange = () => {

    }
    setCloseModal = () => {
        this.setState({viewUsersModal: false});
    };

    viewArrow = (param: boolean) =>
    {
        if(param)
        {
            return "keyboard_arrow_down"
        }
        else
        {
            return "keyboard_arrow_up"

        }

    }

    viewUsers = (param: boolean, roleId: string, roleType:string) =>
        {
            this.setState({viewUsersModal: param })
            this.setState({ selectedRoleUsers: this.state.roleData[roleType].roles.filter((item: any) => item.id === roleId)[0]});
        }

    public onSaveChanges = () => {
        this.setState({roleStatus: true, roleData: dummyData, filterModalOpen: false})
    };

    render() {
        return (

            <div className="student-course  activities-dashboard" style={{minHeight: "100vh"}}>



                {this.state.filterModalOpen && (
                <RolesModal
                isProjectSubActivity={this.props!}
                modalIsOpen={true}
                onClose={this.triggerRoleModal}
                onSaveChanges={this.onSaveChanges}
                />
                )}
                {this.state.viewUsersModal && (

                <Modal
                        id="chatpanel-popup"
                        keyboard={false}
                        isOpen={this.state.viewUsersModal}
                        contentClassName={'chat_modal_width'}
                        modalClassName={'survey-modal-fade'}
                        zIndex={9999}
                        toggle={this.props.triggerModal}
                        style={{marginTop: "150px"}}

                    >
                      <div className="modal-header"  style={{border: "0px", backgroundColor: "#fbfaf6"}}>
                      <h5 className="modal-title d-flex align-items-center">
                                              {T.t('r_role_users')}
                                                </h5>
                                        <button
                                            onClick={this.setCloseModal}
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"

                                        >
                                            <i style={{ color: '#000' }} className="material-icons">
                                                close
                                            </i>
                                        </button>
                                    </div>

                        <div className="modal-content p-4"  style={{border: "0px", backgroundColor: "#fbfaf6"}}>
                            <div className="modal-body p-0">
                                <div className="row" style={{ marginTop: 0 }}>
                                    <div className="col-12">
                                    <Table className="table-user-list table-ellipsis table-mobile" striped={true} hover={true} borderless={true}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#eaeaea' }}>
                                            <th scope="col" className="text-center">
                                                {T.t('r_profile_photo')}
                                            </th>
                                            <th className="text-center">{T.t('r_firstname')}</th>
                                            <th className="text-center">{T.t('r_lastname')}</th>
                                            <th className="text-center">{T.t('r_username')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.selectedRoleUsers.users.map((item: any) => {
                                            return (
                                                <tr key={'student-' + item.userId} data-title={item.userName} style={{ cursor: 'initial' }}>
                                                    <td data-label="Profil Resmi" className="text-center">
                                                    -
                                                    </td>
                                                    <td data-label={T.t('r_firstname')} className="text-center">
                                                        {item.name}
                                                    </td>
                                                    <td data-label={T.t('r_lastname')} className="text-center">
                                                        {item.surname}
                                                    </td>
                                                    <td data-label={T.t('r_username')} className="text-center">
                                                        {item.username}
                                                    </td>

                                                </tr>
                                            );
                                        })}
                                    </tbody>

                                </Table>
                                    <Paginate
                                        filters={{
                                            skip: 0,
                                            take: 10,
                                            page: this.state.notificationPage,
                                            total: this.props.totalCount
                                        }}
                                        onPageChange={this.onPageChange}
                                    />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                        )}
                <div className="container">
                <div className='d-flex justify-content-between'>
    <div> <span><b>{T.t('r_system_roles')}</b></span></div>
    <div><button className="ml-2 category-tag-square tag-green" onMouseDown={this.triggerRoleModal}>+ {T.t('r_system_roles_new')}</button>
    </div>
</div>
                <div  className="row student-course-header question-filter pt-0 pb-3">

                <div className="col-md-6">
                {(!this.state.roleStatus) ?
                    (
                    <>

                    <div className='col-md-12 text-center not_found' style={{paddingTop: "70px"}}>

                    <img src={_common.GetDefaultImages('_role_not_found')} alt="" />
                    <b>{T.t('r_system_roles_no_role')}</b>
                    <p className='small text-center'>{T.t('r_system_roles_no_role_info')}</p>
                    </div>
                    </>
                    ):
                    (
                        <div className='col-md-12 mt-2'  style={{marginTop: "40px", marginRight: "0px", marginLeft: "0px"}}>
                        <div className='row p-0 m-0'>
                            <div className='col-md-10 p-0 m-0' style={{borderBottom: "1px solid #cccccc"}}><b>{T.t('r_admin')}</b></div>
                            <div className='col-md-2 p-0 m-0'></div>
                        </div>


                                {

                                this.state.roleData.admin.roles.map((x: any) => (
                                    <Roles editRoleFunc={this.editRoleFunc} data={x} triggerRoleModal={this.triggerRoleModal} viewUsers={this.viewUsers} deleteModal={this.deleteModal}
                                    viewUsersModal={this.state.viewUsersModal} roleType={'admin'}
                                    ></Roles>
                                ))


                                }

                      <div className='row p-0 '  style={{marginTop: "40px", marginRight: "0px", marginLeft: "0px"}}>
                            <div className='col-md-10 p-0 m-0' style={{borderBottom: "1px solid #cccccc"}}><b>{T.t('r_program_admin')}</b></div>
                            <div className='col-md-2 p-0 m-0'></div>
                        </div>


                        {

this.state.roleData.programAdmin.roles.map((x: any) => (
<Roles editRoleFunc={this.editRoleFunc} data={x} triggerRoleModal={this.triggerRoleModal} viewUsers={this.viewUsers} deleteModal={this.deleteModal}
viewUsersModal={this.state.viewUsersModal} roleType={'programAdmin'}
></Roles>
))


}

<div className='row p-0'  style={{marginTop: "40px", marginRight: "0px", marginLeft: "0px"}}>
                            <div className='col-md-10 p-0 m-0' style={{borderBottom: "1px solid #cccccc"}}><b>{T.t('r_gen_teacher')}</b></div>
                            <div className='col-md-2 p-0 m-0'></div>
                        </div>

                        {

this.state.roleData.educator.roles.map((x: any) => (
<Roles editRoleFunc={this.editRoleFunc} data={x} triggerRoleModal={this.triggerRoleModal} viewUsers={this.viewUsers} deleteModal={this.deleteModal}
viewUsersModal={this.state.viewUsersModal} roleType={'educator'}
></Roles>
))


}

<div className='row p-0 ' style={{marginTop: "40px", marginRight: "0px", marginLeft: "0px"}}>
                            <div className='col-md-10 p-0 m-0' style={{borderBottom: "1px solid #cccccc"}}><b>{T.t('r_gen_student')}</b></div>
                            <div className='col-md-2 p-0 m-0'></div>
                        </div>

                        {

this.state.roleData.student.roles.map((x: any) => (
<Roles editRoleFunc={this.editRoleFunc} data={x} triggerRoleModal={this.triggerRoleModal} viewUsers={this.viewUsers} deleteModal={this.deleteModal}
viewUsersModal={this.state.viewUsersModal} roleType={'student'}
></Roles>
))


}

                    </div>
                    )}
                    </div>
                    <div className="col-md-6">
                    {(!this.state.editRole) ?
                    (
                                <div className='text-md-left'>
                                <div className='row' style={{paddingInlineStart: "13px"}}>
                                    <div>
                                <b><i className='material-icons'>info</i></b>
                                </div>
                                <div className='pb-3' style={{paddingInlineStart: "2px"}}> <b>{T.t('r_system_roles_info')}</b></div>
                                </div>
                                <div className='small pb-5' style={{paddingInlineStart: "2px"}}  dangerouslySetInnerHTML={ { __html: T.t('r_system_role_info1') } }></div>
                                <div className='row'>
                                    <div>
                                <b><i className='material-icons'>info</i></b>
                                </div>
                                <div className='pb-3' style={{paddingInlineStart: "2px"}}> <b>{T.t('r_system_roles_unit_info')}</b></div>
                                </div>


                                <div className='small' style={{paddingInlineStart: "2px"}}  dangerouslySetInnerHTML={ { __html: T.t('r_system_role_info2') } }></div>

                                </div>
                    ):
                    (


                        <div className='row pt-3'>



<div className='my-4 header-scroll col-12 p-2' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'>
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'activitySettings'}
                            name={'activitySettings'}
                            onChange={(e: any) => this.switchEdit('activitySettings', e)}
                            checked={this.state.activitySettings}
                            onColor="#358730"
                            onHandleColor="#358730"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        />
</div>
<div className='col-10' style={{paddingInlineStart: "40px"}}>
                       <b>{T.t('r_system_roles_activity_process')}</b></div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons mb-1" data-event="14" style={{float: "inline-end", paddingInlineEnd: "1rem", paddingInlineStart: "1rem",border : "none", background: "none"}}>{this.viewArrow(this.state.activitySettings)}</button>
    </div>
</div>

{(this.state.activitySettings) &&
                        (
                            <div>
                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'createActivity'}
                                                            name={'createActivity'}
                                                            onChange={(e: any) => this.switchEdit('createActivity', e)}
                                                            checked={this.state.createActivity >= 0 ? this.state.createActivity : this.state.selectedRole.settings.activityOperations.create}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_create_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'deleteActivity'}
                                                            name={'deleteActivity'}
                                                            onChange={(e: any) => this.switchEdit('deleteActivity', e)}
                                                            checked={this.state.deleteActivity >= 0 ? this.state.deleteActivity : this.state.selectedRole.settings.activityOperations.delete}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_delete_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'emailActivity'}
                                                            name={'emailActivity'}
                                                            onChange={(e: any) => this.switchEdit('emailActivity', e)}
                                                            checked={this.state.emailActivity >= 0 ? this.state.emailActivity : this.state.selectedRole.settings.activityOperations.email}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_send_announcement_email')}</div>
                                                        </div>
                                                        </div>
                                </div>
                            </div>
                        )
                        }

</div>

<div className='header-scroll col-12 p-2 mb-4' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'>
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'announcement'}
                            name={'announcement'}
                            onChange={(e: any) => this.switchEdit('announcement', e)}
                            checked={this.state.announcementProcess}
                            onColor="#358730"
                            onHandleColor="#358730"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        />
</div>
<div className='col-10' style={{paddingInlineStart: "40px"}}>
                       <b> {T.t('r_system_roles_announcement_process')}</b></div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons mb-1" data-event="14" style={{float: "inline-end", paddingInlineEnd: "1rem", paddingInlineStart: "1rem",border : "none", background: "none"}}>{this.viewArrow(this.state.announcementProcess)}</button>
    </div>
</div>

{(this.state.announcementProcess) &&
                        (
                            <div>
                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'createAnnouncement'}
                                                            name={'createAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('createAnnouncement', e)}
                                                            checked={this.state.createAnnouncement >= 0 ? this.state.createAnnouncement : this.state.selectedRole.settings.announcementOperations.create}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_create_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'deleteAnnouncement'}
                                                            name={'deleteAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('deleteAnnouncement', e)}
                                                            checked={this.state.deleteAnnouncement >= 0 ? this.state.deleteAnnouncement : this.state.selectedRole.settings.announcementOperations.delete}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_delete_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'emailAnnouncement'}
                                                            name={'emailAnnouncement'}
                                                            onChange={(e: any) => this.switchEdit('emailAnnouncement', e)}
                                                            checked={this.state.emailAnnouncement >= 0 ? this.state.emailAnnouncement : this.state.selectedRole.settings.announcementOperations.email}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_send_announcement_email')}</div>
                                                        </div>
                                                        </div>
                                </div>
                            </div>
                        )
                        }

</div>

<div className='header-scroll col-12 p-2 mb-4' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'>
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'questionBank'}
                            name={'questionBank'}
                            onChange={(e: any) => this.switchEdit('questionBank', e)}
                            checked={this.state.questionBankProcess}
                            onColor="#358730"
                            onHandleColor="#358730"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        />
</div>
<div className='col-10' style={{paddingInlineStart: "40px"}}>
                        <b>{T.t('r_system_roles_question_bank_process')}</b></div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons mb-1" data-event="14" style={{float: "inline-end", paddingInlineEnd: "1rem", paddingInlineStart: "1rem",border : "none", background: "none"}}>{this.viewArrow(this.state.questionBankProcess)}</button>
    </div>
</div>

{(this.state.questionBankProcess) &&
                        (
                            <div>
                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'createQuestion'}
                                                            name={'createQuestion'}
                                                            onChange={(e: any) => this.switchEdit('createQuestion', e)}
                                                            checked={this.state.createQuestion >= 0 ? this.state.createQuestion : this.state.selectedRole.settings.questionBankOperations.create}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_create_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'deleteQuestion'}
                                                            name={'deleteQuestion'}
                                                            onChange={(e: any) => this.switchEdit('deleteQuestion', e)}
                                                            checked={this.state.deleteQuestion >= 0 ? this.state.deleteQuestion : this.state.selectedRole.settings.questionBankOperations.delete}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_delete_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'emailQuestion'}
                                                            name={'emailQuestion'}
                                                            onChange={(e: any) => this.switchEdit('emailQuestion', e)}
                                                            checked={this.state.emailQuestion >= 0 ? this.state.emailQuestion : this.state.selectedRole.settings.questionBankOperations.email}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_send_announcement_email')}</div>
                                                        </div>
                                                        </div>
                                </div>
                            </div>
                        )
                        }

</div>


   <div className='header-scroll col-12 p-2' style={{border: "1px solid #00000042", cursor: "pointer", backgroundColor: "white" }}>

<div className='row'>
<div className='col-9'>
<div className='row'>
<div className='col-2 text-center'>
 <Switch
                            id={'help'}
                            name={'help'}
                            onChange={(e: any) => this.switchEdit('help', e)}
                            checked={this.state.helpProcess}
                            onColor="#358730"
                            onHandleColor="#358730"
                            handleDiameter={30}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                        />
</div>
<div className='col-10' style={{paddingInlineStart: "40px"}}>
                       <b> {T.t('r_system_roles_help_request_process')}</b></div>
                        </div>
                        </div>
<div className='col-3 pr-2'>
    <button className="material-icons mb-1 " data-event="14" style={{float: "inline-end", paddingInlineEnd: "1rem", paddingInlineStart: "1rem",border : "none", background: "none"}}>{this.viewArrow(this.state.helpProcess)}</button>
    </div>
</div>

{(this.state.helpProcess) &&
                        (
                            <div>
                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'createHelp'}
                                                            name={'createHelp'}
                                                            onChange={(e: any) => this.switchEdit('createHelp', e)}
                                                            checked={this.state.createHelp >= 0 ? this.state.createHelp : this.state.selectedRole.settings.helpOperations.create}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_create_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'deleteHelp'}
                                                            name={'deleteHelp'}
                                                            onChange={(e: any) => this.switchEdit('deleteHelp', e)}
                                                            checked={this.state.deleteHelp >= 0 ? this.state.deleteHelp : this.state.selectedRole.settings.helpOperations.delete}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_delete_announcement')}</div>
                                                        </div>
                                                        </div>
                                </div>

                                <div className='row mt-2' style={{marginInlineStart: "1.5rem"}}><div className='col-12'>
                                <div className='row'>
                                <div className='col-2 text-center'>
                                <Switch
                                                            id={'emailHelp'}
                                                            name={'emailHelp'}
                                                            onChange={(e: any) => this.switchEdit('emailHelp', e)}
                                                            checked={this.state.emailHelp >= 0 ? this.state.emailHelp : this.state.selectedRole.settings.helpOperations.email}
                                                            onColor="#358730"
                                                            onHandleColor="#358730"
                                                            handleDiameter={30}
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                            height={20}
                                                            width={48}
                                                            className="react-switch"
                                                        /> </div>
                                                        <div className='col-10'>
                                                        {T.t('r_system_roles_send_announcement_email')}</div>
                                                        </div>
                                                        </div>
                                </div>
                            </div>
                        )
                        }

</div>

<div className="modal-footer d-block col-12" style={{paddingInlineEnd: "0px", paddingInlineStart: "0px"}}>
                                <div className="row">
                                    <div className="col-md">
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                        >
                                            {T.t('r_cancel_button')}
                                        </button>
                                    </div>
                                    <div className="col-md text-md-right">
                                        <button
                                            type="button"
                                            className="btn btn-success mobile-margin ml-2"
                                        >
                                            {T.t('r_gen_save')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>



                    )}
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default withRouter(RolesPage);
